import { inject } from "aurelia-framework";
import { LocaleService } from "../services/locale-service";

@inject(LocaleService)
export class NumberValueConverter {
  constructor(private localeService: LocaleService) {}

  toView(value: any, formatMask: string): string {
    if (value === undefined || value === null || value == "") return value;
    return this.localeService.formatNumber(value, formatMask);
  }
}
